import {immerable} from "immer";
import GeometryRepresentationOperation from "@/models/enums/geometry-representation-operation.ts";

class GeometryRepresentation {
    [immerable] = true;
    
    geometryRepresentationId: string | undefined;
    
    geometryId: string;
    
    operation: GeometryRepresentationOperation;
    
    constructor(geometryId: string, operation: GeometryRepresentationOperation, geometryRepresentationId?: string) {
        this.geometryId = geometryId;
        this.operation = operation;
        this.geometryRepresentationId = geometryRepresentationId;
    }
}

export default GeometryRepresentation;